const PRIVATE_FIELDS = [
  'der_file',
  'key_file',
  'certificate_password',
  'account_token',
  'account_password',
  'card_authentication',
  'card_number',
  'card_password',
  'login_card_no',
  'sms_auth_no',
  'authentication_id',
  'two_way_info',
  'jti',
  'password',
  'authentication',
  'authorization',
];
const PRIVATE_KEYS = new Set(PRIVATE_FIELDS.map(key => key.replace(/_/g, '')));
const PRIVATE_FIELD_PATTERN = PRIVATE_FIELDS.map(key => key.replace(/_/g, '[_-]?')).join('|');
// 따옴표 없는 비밀값은 경계를 확신할 수 없어 뒤의 문자열도 함께 마스킹한다.
const PRIVATE_VALUE_PATTERN = new RegExp(
  String.raw`(\b(?:${PRIVATE_FIELD_PATTERN})["']?\s*(?:=|:)\s*)(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|[\s\S]+)`,
  'gi'
);

const sanitizeText = (value: string) =>
  value
    .replace(
      /-----BEGIN (CERTIFICATE|(?:RSA |EC |ENCRYPTED )?PRIVATE KEY)-----[\s\S]*?(?:-----END \1-----|$)/g,
      '[REDACTED]'
    )
    .replace(PRIVATE_VALUE_PATTERN, '$1[REDACTED]')
    .replace(/\b(Bearer|Basic)\s+[A-Za-z0-9+/_=.~-]+/gi, '$1 [REDACTED]');

const sanitize = (value: unknown, seen: WeakSet<object>): unknown => {
  if (typeof value === 'string') {
    try {
      const parsed: unknown = JSON.parse(value);
      if (parsed && typeof parsed === 'object') {
        return JSON.stringify(sanitize(parsed, seen));
      }
    } catch {
      // 일반 로그 문자열의 JSON 파싱 실패가 로깅 자체를 중단하지 않도록 한다.
    }
    return sanitizeText(value);
  }
  if (!value || typeof value !== 'object') return value;
  if (seen.has(value)) return '[Circular]';
  seen.add(value);

  if (value instanceof Error) {
    // stack에는 원문 message가 포함되므로 정제한 진단 필드만 남긴다.
    return sanitize(
      {
        ...Object.fromEntries(Object.entries(value).filter(([key]) => key !== 'stack')),
        name: value.name,
        message: value.message,
        ...('cause' in value ? { cause: value.cause } : {}),
      },
      seen
    );
  }

  if (Array.isArray(value)) {
    return value.map(item => sanitize(item, seen));
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [
      key,
      PRIVATE_KEYS.has(key.replace(/[_-]/g, '').toLowerCase()) ? '[REDACTED]' : sanitize(item, seen),
    ])
  );
};

export const sanitizeCertificateLogContext = (context: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(context).map(([key, value]) => [
      key,
      PRIVATE_KEYS.has(key.replace(/[_-]/g, '').toLowerCase()) ? '[REDACTED]' : sanitize(value, new WeakSet()),
    ])
  );
